import { render, staticRenderFns } from "./ActionsColumnTemplate.vue?vue&type=template&id=6af16347"
import script from "./ActionsColumnTemplate.vue?vue&type=script&lang=js"
export * from "./ActionsColumnTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports